import { FC } from 'react';
import { FooterProps } from '../Footer';
import { GettingStartedFooter } from '../../Layouts/GettingStartedLayout/GettingStartedFooter';

export const GettingStartedPauseSkipAnytimeFooter: FC<FooterProps> = props => (
  <GettingStartedFooter {...props} icon="pause" text="Pause, skip at anytime" />
);
